/**
 * DIY 页面装修 - 组件菜单面板
 *
 * 提供可视化装修页面的组件选择面板，按分类展示可添加的装修组件，
 * 点击后将对应组件的默认配置插入到表单数据列表中。
 *
 * 组件分类：
 * - 基础组件：图文导航、轮播广告、公告、标题、图片广告、视频、文章列表、图文详情、弹窗组件、底部导航
 * - 公司组件：营业执照、其他资质、公司图片、公司信息、代理商信息（仅溯源页）
 * - 产品组件（仅溯源页）：产品属性、产品样册、质检报告、实例节点、查询结果、产品信息、产品图片
 * - 售后组件（仅溯源页）：质保信息
 * - 其他组件（仅溯源页）：批次属性、批次质检报告、监测数据、状态面板、动态数据面板
 *
 * @props {Number} active_id  - 当前选中组件的索引，-1 表示未选中；大于 0 时新组件插入到该索引之后
 * @props {String} diy_id     - 页面类型标识，"1" 为溯源页（显示产品/售后/其他组件），其他值仅显示基础和公司组件
 * @props {Array}  formData   - 页面组件数据列表，新组件将插入此数组
 * @props {Object} popData    - 弹窗组件的默认数据，用于 getPop 方法插入弹窗组件
 *
 * @data {String} admin_id  - 当前管理员 ID，从 localStorage 获取，用于生成组件唯一 key
 * @data {Number} index_id  - 计算得出的插入位置索引
 *
 * @method getPop() - 插入弹窗组件（type=21），若已存在则跳过，插入到 formData 索引 1 的位置
 * @method menuClick(e) - 根据组件类型编号 e 将对应默认配置插入 formData，
 *   部分组件（查询结果 type=17、批次属性 type=22、质保信息 type=25、底部导航 type=26）限制每页仅可添加一个
 */
<!-- 基本组件 公司组件 产品组件 -->
<template>
    <div>
        <div class="card">
            <div class="flex-sb" @click="basicVisible = !basicVisible">
                <span class="title">基础组件</span>
                <Icon
                    :type="basicVisible ? 'ios-arrow-up' : 'ios-arrow-down'"
                    size="20"
                    color="#484E66"
                    class="c-p"
                />
            </div>
            <div class="flex-sb flex-w" v-if="basicVisible">
                <div class="card-btn" @click="menuClick(1)">
                    <img class="mr12" src="@/assets/diy/image.png" />
                    <div>图文导航</div>
                </div>
                <div class="card-btn" @click="menuClick(2)">
                    <img class="mr12" src="@/assets/diy/carousel.png" />
                    <div>轮播广告</div>
                </div>
                <div class="card-btn" @click="menuClick(3)">
                    <img class="mr12" src="@/assets/diy/notice.png" />
                    <div>公告</div>
                </div>
                <div class="card-btn" @click="menuClick(4)">
                    <img class="mr12" src="@/assets/diy/title.png" />
                    <div>标题</div>
                </div>
                <div class="card-btn" @click="menuClick(5)">
                    <img
                        class="mr12"
                        src="@/assets/diy/display-advertising.png"
                    />
                    <div>图片广告</div>
                </div>
                <div class="card-btn" @click="menuClick(6)">
                    <img class="mr12" src="@/assets/diy/video.png" />
                    <div>视频</div>
                </div>
                <div class="card-btn" @click="menuClick(7)">
                    <img class="mr12" src="@/assets/diy/article-list.png" />
                    <div>文章列表</div>
                </div>
                <div class="card-btn" @click="menuClick(8)">
                    <img class="mr12" src="@/assets/diy/image-text.png" />
                    <div>图文详情</div>
                </div>
                <div class="card-btn" @click="getPop">
                    <img class="mr12" src="@/assets/diy/popup.png" />
                    <div>弹窗组件</div>
                </div>
                <div class="card-btn" @click="menuClick(26)">
                    <img class="mr12" src="@/assets/diy/popup.png" />
                    <div>底部导航</div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="flex-sb" @click="companyVisible = !companyVisible">
                <span class="title">公司组件</span>
                <Icon
                    :type="companyVisible ? 'ios-arrow-up' : 'ios-arrow-down'"
                    size="20"
                    color="#484E66"
                    class="c-p"
                />
            </div>
            <div class="flex-sb flex-w" v-if="companyVisible">
                <div class="card-btn" @click="menuClick(9)">
                    <img class="mr12" src="@/assets/diy/image.png" />
                    <div>营业执照</div>
                </div>
                <div class="card-btn" @click="menuClick(10)">
                    <img class="mr12" src="@/assets/diy/other.png" />
                    <div>其他资质</div>
                </div>
                <div class="card-btn" @click="menuClick(11)">
                    <img class="mr12" src="@/assets/diy/picture.png" />
                    <div>公司图片</div>
                </div>
                <div class="card-btn" @click="menuClick(12)">
                    <img class="mr12" src="@/assets/diy/notice.png" />
                    <div>公司信息</div>
                </div>
                <div class="card-btn" v-if="diy_id == 1" @click="menuClick(20)">
                    <img class="mr12" src="@/assets/diy/agent.png" />
                    <div>代理商信息</div>
                </div>
            </div>
        </div>
        <div class="card" v-if="diy_id == 1">
            <div class="flex-sb" @click="productVisible = !productVisible">
                <span class="title">产品组件</span>
                <Icon
                    :type="productVisible ? 'ios-arrow-up' : 'ios-arrow-down'"
                    size="20"
                    color="#484E66"
                    class="c-p"
                />
            </div>
            <div class="flex-sb flex-w" v-if="productVisible">
                <div class="card-btn" @click="menuClick(13)">
                    <img class="mr12" src="@/assets/diy/attribute.png" />
                    <div>产品属性</div>
                </div>
                <div class="card-btn" @click="menuClick(27)">
                    <img class="mr12" src="@/assets/diy/code-management.png" />
                    <div>码属性</div>
                </div>
                <div class="card-btn" @click="menuClick(14)">
                    <img class="mr12" src="@/assets/diy/brochure.png" />
                    <div>产品样册</div>
                </div>
                <div class="card-btn" @click="menuClick(15)">
                    <img class="mr12" src="@/assets/diy/report.png" />
                    <div>质检报告</div>
                </div>
                <div class="card-btn" @click="menuClick(16)">
                    <img class="mr12" src="@/assets/diy/node.png" />
                    <div>实例节点</div>
                </div>
                <div class="card-btn" @click="menuClick(17)">
                    <img class="mr12" src="@/assets/diy/result.png" />
                    <div>查询结果</div>
                </div>
                <div class="card-btn" @click="menuClick(18)">
                    <img class="mr12" src="@/assets/diy/product-info.png" />
                    <div>产品信息</div>
                </div>
                <div class="card-btn" @click="menuClick(19)">
                    <img class="mr12" src="@/assets/diy/product-img.png" />
                    <div>产品图片</div>
                </div>
            </div>
        </div>
        <div class="card" v-if="diy_id == 1">
            <div class="flex-sb" @click="afterSaleVisible = !afterSaleVisible">
                <span class="title">售后组件</span>
                <Icon
                    :type="afterSaleVisible ? 'ios-arrow-up' : 'ios-arrow-down'"
                    size="20"
                    color="#484E66"
                    class="c-p"
                />
            </div>
            <div class="flex-sb flex-w" v-if="afterSaleVisible">
                <div class="card-btn" @click="menuClick(25)">
                    <img class="mr12" src="@/assets/diy/warranty.png" />
                    <div>质保信息</div>
                </div>
            </div>
        </div>
        <div class="card mb0" v-if="diy_id == 1">
            <div class="flex-sb" @click="otherVisible = !otherVisible">
                <span class="title">其他组件</span>
                <Icon
                    :type="otherVisible ? 'ios-arrow-up' : 'ios-arrow-down'"
                    size="20"
                    color="#484E66"
                    class="c-p"
                />
            </div>
            <div class="flex-sb flex-w" v-if="otherVisible">
                <div class="card-btn" @click="menuClick(22)">
                    <img class="mr12" src="@/assets/diy/batch-attribute.png" />
                    <div>批次属性</div>
                </div>
                <div class="card-btn-none" @click="menuClick(23)">
                    <img class="mr12" src="@/assets/diy/report.png" />
                    <div>批次质检报告</div>
                </div>
                <div class="card-btn" @click="menuClick(24)">
                    <img class="mr12" src="@/assets/diy/monitor.png" />
                    <div>监测数据</div>
                </div>
                <div class="card-btn" @click="menuClick(28)">
                    <img class="mr12" src="@/assets/diy/statuspanel.png" />
                    <div>状态面板</div>
                </div>
                <div class="card-btn-none" @click="menuClick(29)">
                    <img class="mr12" src="@/assets/diy/dynamicdatapanel.png" />
                    <div>动态数据面板</div>
                </div>
                <div class="card-btn-none" @click="menuClick(30)">
                    <img class="mr12" src="@/assets/diy/controlpanel.png" />
                    <div>操作面板</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 生成表单字段唯一标识 field_key（与 addForm 组件保持一致的格式）
function generateFieldKey(type) {
    let admin_id = "";
    try {
        admin_id = localStorage.getItem("admin_id") || "";
    } catch (e) {
        // 忽略 localStorage 不可用的情况
    }
    return (
        admin_id +
        "_" +
        type +
        "_" +
        Date.now() +
        "_" +
        Math.random().toString(36).slice(2, 6)
    );
}

export default {
    props: {
        active_id: {
            type: Number,
            default: -1,
        },
        diy_id: {
            type: String,
            default: "0",
        },
        formData: {
            type: Array,
            default: () => [],
        },
        popData: {
            type: Object,
            default: () => ({}),
        },
        // DIY页面ID，用于判断是否需要初始化多场景数据（id=1102时启用3场景模式）
        pageId: {
            type: String,
            default: "1102",
        },
    },
    data() {
        return {
            admin_id: "",
            index_id: -1,
            // 基础组件展开状态
            basicVisible: true,
            // 公司组件展开状态
            companyVisible: true,
            // 产品组件展开状态
            productVisible: true,
            // 售后组件展开状态
            afterSaleVisible: true,
            // 其他组件展开状态
            otherVisible: true,
        };
    },
    created() {
        try {
            this.admin_id = localStorage.getItem("admin_id") || "";
        } catch (e) {
            console.warn("localStorage 读取失败:", e);
            this.admin_id = "";
        }
    },
    methods: {
        getPop() {
            const hasPopup = this.formData.some((item) => item.type === 21);
            if (!hasPopup) {
                this.formData.splice(1, 0, this.popData);
            }
        },
        // 左侧菜单点击
        menuClick(e) {
            this.index_id = this.formData.length;
            if (this.active_id > 0) {
                this.index_id = this.active_id + 1;
            }
            switch (e) {
                // -1：搜索组件
                // 0：背景设置
                case 1:
                    this.formData.splice(this.index_id, 0, {
                        type: 1,
                        name: "图文导航",
                        content: {
                            version: 1, //版本号 - 兼容新老版本
                            type_id: 1, //导航样式
                            title_color: "#000",
                            text_color: "#999",
                            iconList: [
                                {
                                    value: "/icon/diys/smail.png",
                                    picview:
                                        "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                    title: "标题",
                                    describe: "功能描述",
                                    action_id: 1,
                                    link_id: 1,
                                    link_name: "",
                                    imgList: [{ value: "", picview: "" }],
                                    clerk: "文案标题",
                                    clerk_value: 0,
                                },
                                {
                                    value: "/icon/diys/smail.png",
                                    picview:
                                        "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                    title: "标题",
                                    describe: "功能描述",
                                    action_id: 1,
                                    link_id: 1,
                                    link_name: "",
                                    imgList: [{ value: "", picview: "" }],
                                    clerk: "文案标题",
                                    clerk_value: 0,
                                },
                                {
                                    value: "/icon/diys/smail.png",
                                    picview:
                                        "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                    title: "标题",
                                    describe: "功能描述",
                                    action_id: 1,
                                    link_id: 1,
                                    link_name: "",
                                    imgList: [{ value: "", picview: "" }],
                                    clerk: "文案标题",
                                    clerk_value: 0,
                                },
                            ],
                            type_value: "1",
                            txt_size: "13",
                            txt_color_active: "#000",
                            txt_color: "#000",
                            active_img: { value: "", picview: "" },
                            nav_img: { value: "", picview: "" },
                            clerk_color: "#000",
                            clerk_size: "13",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 2:
                    this.formData.splice(this.index_id, 0, {
                        type: 2,
                        name: "轮播广告",
                        content: {
                            version: 1,
                            autoplay: "1",
                            time: "3",
                            height: "150",
                            bannerList: [
                                {
                                    value: "",
                                    picview:
                                        "https://suyuan.hulianzaowu.com/icon/diys/banner.png",
                                    action_id: 1,
                                    link_id: 1,
                                    link_name: "",
                                },
                            ],
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 3:
                    this.formData.splice(this.index_id, 0, {
                        type: 3,
                        name: "公告",
                        content: {
                            version: 1,
                            text: "文字展示",
                            size: "15",
                            text_color: "#000",
                            rollValue: 0,
                            rollSpeed: 100,
                            imgs: {
                                value: "/icon/diys/notice.png",
                                picview:
                                    "https://suyuan.hulianzaowu.com/icon/diys/notice.png",
                            },
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 4:
                    this.formData.splice(this.index_id, 0, {
                        type: 4,
                        name: "标题",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            text: "标题",
                            size: "20",
                            position: "left",
                            text_color: "#000",
                            dec_color: "#FF761D ",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 5:
                    this.formData.splice(this.index_id, 0, {
                        type: 5,
                        name: "图片广告",
                        content: {
                            version: 1,
                            style_id: 0, //图片样式id
                            imgList: [{ value: "", picview: "" }],
                            hotspot: [],
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                            preview_value: 1,
                        },
                    });
                    break;
                case 6:
                    this.formData.splice(this.index_id, 0, {
                        type: 6,
                        name: "视频",
                        content: {
                            version: 1,
                            height: "150",
                            autoplay: "1", //播放方式
                            loop: 1, //循环播放
                            videoList: {
                                value: "/unidoc/zh/2minute-demo.mp4",
                                picview:
                                    "https://qiniu-web-assets.dcloud.net.cn/unidoc/zh/2minute-demo.mp4",
                            },
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 7:
                    this.formData.splice(this.index_id, 0, {
                        type: 7,
                        name: "文章列表",
                        content: {
                            article_style: "1",
                            articel_type_id: null,
                            version: 1,
                            title_size: "15",
                            title_color: "#000000",
                            time_value: 1,
                            time_color: "#666666",
                            btn_value: 0,
                            btn_color: "#fff",
                            border_color: "#FF761D ",
                            btn_text_color: "#FF761D ",
                            mask_color: "#FFF8F4",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 8:
                    // 当 pageId=1102 时，使用3场景数据结构
                    if (String(this.pageId) === "1102") {
                        this.formData.splice(this.index_id, 0, {
                            type: 8,
                            name: "图文详情",
                            content: {
                                version: 1,
                                scene_value: 1,
                                scenes: [
                                    {
                                        text: "普通中空质保书",
                                        btn_value: 0,
                                        btn_color: "#fff",
                                        border_color: "#FF761D",
                                        btn_text_color: "#FF761D",
                                        mask_color: "#FFF8F4",
                                    },
                                    {
                                        text: "4SG玻璃质保书",
                                        btn_value: 0,
                                        btn_color: "#fff",
                                        border_color: "#FF761D",
                                        btn_text_color: "#FF761D",
                                        mask_color: "#FFF8F4",
                                    },
                                    {
                                        text: "感谢文案",
                                        btn_value: 0,
                                        btn_color: "#fff",
                                        border_color: "#FF761D",
                                        btn_text_color: "#FF761D",
                                        mask_color: "#FFF8F4",
                                    },
                                ],
                                bg_color: "#fff",
                                bg_value: 0,
                                bg_img: { value: "", picview: "" },
                                marginData: { top: 0, left: 0 },
                                paddingData: { top: 12, left: 12 },
                                radiusData: { top: 0, bottom: 0 },
                            },
                        });
                    } else {
                        this.formData.splice(this.index_id, 0, {
                            type: 8,
                            name: "图文详情",
                            content: {
                                version: 1,
                                menu_value: 1,
                                text: "图文详情",
                                btn_value: 0,
                                btn_color: "#fff",
                                border_color: "#FF761D ",
                                btn_text_color: "#FF761D ",
                                mask_color: "#FFF8F4",
                                bg_color: "#fff",
                                bg_value: 0,
                                bg_img: { value: "", picview: "" },
                                marginData: { top: 0, left: 0 },
                                paddingData: { top: 12, left: 12 },
                                radiusData: { top: 0, bottom: 0 },
                            },
                        });
                    }
                    break;
                case 9:
                    this.formData.splice(this.index_id, 0, {
                        type: 9,
                        name: "营业执照",
                        content: {
                            version: 1,
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 10:
                    this.formData.splice(this.index_id, 0, {
                        type: 10,
                        name: "其他资质",
                        content: {
                            version: 1,
                            style_id: 0,
                            autoplay: "0",
                            indicator_color: "#fff",
                            imgList: [{ value: "", picview: "" }],
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 11:
                    this.formData.splice(this.index_id, 0, {
                        type: 11,
                        name: "公司图片",
                        content: {
                            version: 1,
                            style_id: 0,
                            autoplay: "0",
                            indicator_color: "#fff",
                            imgList: [{ value: "", picview: "" }],
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 12:
                    this.formData.splice(this.index_id, 0, {
                        type: 12,
                        name: "公司信息",
                        content: {
                            version: 1,
                            title_color: "#FF5000",
                            title_size: "20",
                            title_bg_color: "#fff",
                            title_border_color: "#ccc",
                            text_color: "#999",
                            txt_color: "#000",
                            size: "15",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 13:
                    this.formData.splice(this.index_id, 0, {
                        type: 13,
                        name: "产品属性",
                        // 生成4-5位随机数 (1000 到 99999)
                        key: this.admin_id + "a" + Date.now(),
                        // key: `${
                        //     this.admin_id || "default"
                        // }_${Date.now()}_${Math.random()
                        //     .toString(36)
                        //     .substr(2, 9)}`,
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            position: "left",
                            dec_color: "#FF761D ",
                            title: "产品属性",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            text_size: "15",
                            text_color: "#999",
                            txt_size: "15",
                            txt_color: "#000",
                            attributeData: [
                                {
                                    attribute_id: "",
                                    attribute_name: "",
                                    attribute_content: [],
                                },
                            ],
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                            border_color: "#434343",
                        },
                    });
                    break;
                case 14:
                    this.formData.splice(this.index_id, 0, {
                        type: 14,
                        name: "产品样册",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            style_id: 0, //图片样式
                            title: "产品样册",
                            position: "left",
                            dec_color: "#FF761D ",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            text_size: "15",
                            text_color: "#FF5000",
                            btn_value: 0,
                            btn_color: "#fff",
                            border_color: "#FF761D ",
                            btn_text_color: "#FF761D ",
                            mask_color: "#FFF8F4",
                            imgList: [{ value: "", picview: "" }],
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 15:
                    this.formData.splice(this.index_id, 0, {
                        type: 15,
                        name: "产品质检报告",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            position: "left",
                            dec_color: "#FF761D ",
                            style_set: "1", //样式设置
                            style_id: 0, //平铺样式
                            autoplay: "1",
                            time: "3",
                            imgList: [{ value: "", picview: "" }],
                            title: "报告标题",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            text_color: "#FF5000",
                            text_size: "15",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 16:
                    this.formData.splice(this.index_id, 0, {
                        type: 16,
                        name: "实例节点",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            position: "left",
                            dec_color: "#FF761D ",
                            title: "产品节点",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            mould_size: "15",
                            mould_color: "#000",
                            text_size: "15",
                            text_color: "#FF5000",
                            txt_size: "13",
                            txt_color: "#000",
                            mode_id: "1",
                            line_color: "#D0D5EE",
                            circle_color: "#FF761D ",
                            btn_value: 0,
                            btn_color: "#fff",
                            border_color: "#FF761D ",
                            btn_text_color: "#FF761D ",
                            mask_color: "#FFF8F4",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            mode_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 17:
                    // 设置查询结果组件只push一次
                    var value;
                    value = this.formData.some((item) => item.type == 17);
                    if (value) {
                        return;
                    }
                    this.formData.splice(this.index_id, 0, {
                        type: 17,
                        name: "查询结果",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            position: "left",
                            dec_color: "#FF761D ",
                            title: "查询结果",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            text_size: "15",
                            text_color: "#000000",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 18:
                    // 当 pageId=1102 时，使用自定义字段数据结构
                    if (String(this.pageId) === "1102") {
                        this.formData.splice(this.index_id, 0, {
                            type: 18,
                            name: "产品信息",
                            content: {
                                version: 1,
                                custom_mode: 1,
                                fields: {
                                    order_no: 1,
                                    project_name: 1,
                                    product_name: 1,
                                    product_size: 1,
                                    product_area: 1,
                                    floor_no: 1,
                                    process_req: 1,
                                    factory_time: 1,
                                    warranty_duration: 1,
                                    warranty_remaining: 1,
                                },
                                style_value: "1",
                                img_value: "1",
                                position: "left",
                                dec_color: "#FF761D ",
                                title: "",
                                title_size: "20",
                                title_color: "#FF5000",
                                title_border_color: "#ccc",
                                title_bg_color: "#fff",
                                text_color: "#000",
                                text_size: "15",
                                txt_color: "#000",
                                txt_size: "15",
                                bg_color: "#fff",
                                bg_value: 0,
                                bg_img: { value: "", picview: "" },
                                marginData: { top: 0, left: 0 },
                                paddingData: { top: 12, left: 12 },
                                radiusData: { top: 0, bottom: 0 },
                            },
                        });
                    } else {
                        this.formData.splice(this.index_id, 0, {
                            type: 18,
                            name: "产品信息",
                            content: {
                                version: 1,
                                style_value: "1", //标题样式
                                img_value: "1", //产品图片
                                position: "left",
                                dec_color: "#FF761D ",
                                title: "产品信息",
                                title_size: "20",
                                title_color: "#FF5000",
                                title_border_color: "#ccc",
                                title_bg_color: "#fff",
                                text_color: "#999",
                                text_size: "15",
                                txt_color: "#000",
                                txt_size: "15",
                                value1: 1,
                                value2: 1,
                                value3: 1,
                                value4: 1,
                                value5: 1,
                                value6: 1,
                                value7: 1,
                                value8: 1,
                                value9: 1,
                                bg_color: "#fff",
                                bg_value: 0,
                                bg_img: { value: "", picview: "" },
                                marginData: { top: 0, left: 0 },
                                paddingData: { top: 12, left: 12 },
                                radiusData: { top: 0, bottom: 0 },
                            },
                        });
                    }
                    break;
                case 19:
                    this.formData.splice(this.index_id, 0, {
                        type: 19,
                        name: "产品图片",
                        content: {
                            version: 1,
                            style_set: "1", //样式设置
                            style_id: 0, //平铺样式
                            autoplay: "1",
                            time: "3",
                            imgList: [{ value: "", picview: "" }],
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 20:
                    this.formData.splice(this.index_id, 0, {
                        type: 20,
                        name: "代理商信息",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            dec_color: "#FF761D ",
                            position: "left",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bc: "#fff",
                            type: ["授权编号", "手机号码", "负责区域"],
                            text_color: "#999",
                            txt_color: "#000",
                            size: "15",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                // 21：弹窗组件
                // 22：批次属性
                case 22:
                    const hasType22 = this.formData.some(
                        (item) => item.type === 22
                    ); //限制
                    if (!hasType22) {
                        this.formData.splice(this.index_id, 0, {
                            type: 22,
                            name: "批次属性",
                            content: {
                                version: 1,
                                style_value: "1", //标题样式
                                position: "left",
                                dec_color: "#FF761D ",
                                headline: "批次属性",
                                headline_size: "20",
                                headline_color: "#FF5000",
                                headline_border_color: "#ccc",
                                headline_bg_color: "#fff",
                                headline_position: "left",
                                title_color: "#FF5000",
                                title_size: "15",
                                text_name_color: "#999",
                                text_name_size: "15",
                                text_color: "#000",
                                text_size: "15",
                                btn_value: 0,
                                btn_color: "#fff",
                                border_color: "#FF761D ",
                                btn_text_color: "#FF761D ",
                                mask_color: "#FFF8F4",
                                bg_color: "#fff",
                                bg_value: 0,
                                bg_img: { value: "", picview: "" },
                                marginData: { top: 0, left: 0 },
                                paddingData: { top: 12, left: 12 },
                                radiusData: { top: 0, bottom: 0 },
                            },
                        });
                        return;
                    } else {
                        this.$Message.error(
                            "批次属性组件限制一个页面只能添加一个"
                        );
                    }
                    break;
                case 23:
                    this.formData.splice(this.index_id, 0, {
                        type: 23,
                        name: "批次质检报告",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            position: "left",
                            dec_color: "#FF761D ",
                            style_set: "1", //样式设置
                            style_id: 0, //平铺样式
                            autoplay: "1",
                            time: "3",
                            imgList: [{ value: "", picview: "" }],
                            title: "报告标题",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            text_color: "#FF5000",
                            text_size: "15",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 24:
                    this.formData.splice(this.index_id, 0, {
                        type: 24,
                        name: "监测数据",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            menuList: [
                                {
                                    title: "菜单名称",
                                    text: {
                                        name: "检测名称",
                                        txt: "数据",
                                        norm: "参考标准",
                                    },
                                    remark: "标准参考值: ≥0%",
                                },
                            ],
                            title_size: "20",
                            title_color_active: "#fff",
                            title_bg_color_active: "#3D3D3D",
                            title_color: "#555555",
                            title_bg_color: "#DCDCDC",
                            remark_color: "#676767",
                            other_color: "#6e6e6e",
                            name_size: "15",
                            name_color: "#333",
                            txt_size: "15",
                            txt_color: "#434343",
                            norm_size: "15",
                            norm_color: "#ccc",
                            border_color: "#ccc",
                            bg_color: "#DCDCDC",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 25:
                    const hasType25 = this.formData.some(
                        (item) => item.type === 25
                    ); //限制
                    if (!hasType25) {
                        this.formData.splice(this.index_id, 0, {
                            type: 25,
                            name: "质保信息",
                            content: {
                                version: 1,
                                style_value: "1", //标题样式
                                title: "质保信息",
                                title_size: "20",
                                position: "left",
                                title_color: "#FF761D ",
                                dec_color: "#FF761D ",
                                dividingline_color: "#eee",
                                title_bg_color: "#fff",
                                text1: "暂未开启质检信息",
                                text_size1: "15",
                                text_color1: "#999",
                                btn_text: "激活质保信息",
                                btn_text_color: "#fff",
                                btn_border_color: "#FF761D ",
                                btn_color: "#FF761D ",
                                tableList: [
                                    {
                                        title_name: "姓名",
                                        name_value: 1,
                                        type: 1,
                                        type_name: "单行文本",
                                        prompt_text: "请输入姓名",
                                        required_value: "1",
                                        display_value: "1",
                                        hide_value: "2",
                                        default: 1,
                                        input_value: null,
                                    },
                                    {
                                        title_name: "手机号",
                                        phone_value: 1,
                                        type: 1,
                                        type_name: "单行文本",
                                        prompt_text: "请输入手机号",
                                        required_value: "1",
                                        display_value: "1",
                                        hide_value: "2",
                                        default: 1,
                                        input_value: null,
                                        phone_value: "1",
                                    },
                                ],
                                title_size2: "15",
                                title_color2: "#333",
                                // prompt_text_color2: "#333",
                                // text_color2: "#333",
                                btn_text2: "提交",
                                btn_text_color2: "#fff",
                                btn_border_color2: "#FF761D ",
                                btn_color2: "#FF761D ",
                                form_txt_size3: "13",
                                form_title_color3: "#000",
                                form_text_color3: "#999",
                                bar_color: "#FF761D ",
                                text3: "激活日期: {#active}<br/>质保期剩余{#surplus}天<br/>{#start} - {#end}",
                                menu_value: 1,
                                bg_color: "#fff",
                                bg_value: 0,
                                bg_img: { value: "", picview: "" },
                                marginData: { top: 0, left: 0 },
                                paddingData: { top: 12, left: 12 },
                                radiusData: { top: 0, bottom: 0 },
                                two_confirm: 0,
                                content2: "富文本内容",
                                btn_value: "3",
                                btn_texts: "确 认",
                                btn_bg_color: "#FF761D ",
                                btn_border_colors: "#FF761D ",
                                txt_color: "#fff",
                                action_id: 3,
                                link_id: 1,
                                link_name: "",
                                btn_texts2: "取消",
                                btn_bg_color2: "#fff",
                                btn_border_colors2: "#ccc",
                                txt_color2: "#999999",
                                action_id2: 4,
                                link_id2: 1,
                                link_name2: "",
                            },
                        });
                        return;
                    } else {
                        this.$Message.error(
                            "质保信息组件限制一个页面只能添加一个"
                        );
                    }
                    break;
                case 26:
                    const hasType26 = this.formData.some(
                        (item) => item.type === 26
                    ); //限制
                    if (!hasType26) {
                        this.formData.splice(this.index_id, 0, {
                            type: 26,
                            name: "底部导航",
                            content: {
                                version: 1, //版本号 - 兼容新老版本
                                txt_color: "#000",
                                none_txt_color: "#999",
                                txt_color2: "#000",
                                iconList: [
                                    {
                                        txt: "首页",
                                        action_id: 5,
                                        link_id: 1,
                                        link_name: "/",
                                        img_list: {
                                            value: "/icon/diys/smail.png",
                                            picview:
                                                "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                        },
                                        none_img_list: {
                                            value: "/icon/diys/smail.png",
                                            picview:
                                                "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                        },
                                    },
                                    {
                                        txt: "我的",
                                        action_id: 6,
                                        link_id: 1,
                                        link_name: "/pages/my/my",
                                        img_list: {
                                            value: "/icon/diys/smail.png",
                                            picview:
                                                "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                        },
                                        none_img_list: {
                                            value: "/icon/diys/smail.png",
                                            picview:
                                                "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                        },
                                    },
                                ],
                                iconList2: [
                                    {
                                        txt: "商城",
                                        action_id: 7,
                                        link_id: 1,
                                        link_name: "/pages/my/mall",
                                        img_list: {
                                            value: "/icon/diys/smail.png",
                                            picview:
                                                "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                        },
                                    },
                                ],
                                bg_color: "#fff",
                                bg_value: 0,
                                bg_img: { value: "", picview: "" },
                            },
                        });
                    } else {
                        this.$Message.error(
                            "底部导航组件限制一个页面只能添加一个"
                        );
                    }
                    break;
                // 27：码属性
                case 27:
                    this.formData.splice(this.index_id, 0, {
                        type: 27,
                        name: "码属性",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            position: "left",
                            dec_color: "#FF761D ",
                            headline: "码属性",
                            headline_size: "20",
                            headline_color: "#FF5000",
                            headline_border_color: "#ccc",
                            headline_bg_color: "#fff",
                            headline_position: "left",
                            text_name_color: "#999",
                            text_name_size: "15",
                            text_color: "#000",
                            text_size: "15",
                            btn_value: 0,
                            btn_color: "#fff",
                            border_color: "#FF761D ",
                            btn_text_color: "#FF761D ",
                            mask_color: "#FFF8F4",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                // 28：状态面板
                case 28:
                    const hasType28 = this.formData.some(
                        (item) => item.type === 28
                    ); //限制
                    if (!hasType28) {
                        this.formData.splice(this.index_id, 0, {
                            type: 28,
                            name: "状态面板",
                            key: this.admin_id + "a" + Date.now(),
                            content: {
                                version: 1,
                                style_value: "1", // 1单列 2双列
                                bg_color: "#fff",
                                bg_value: 0,
                                bg_img: { value: "", picview: "" },
                                marginData: { top: 0, left: 0 },
                                paddingData: { top: 12, left: 12 },
                                radiusData: { top: 0, bottom: 0 },
                                statusList: [
                                    {
                                        title: "状态",
                                        current_status: "正常",
                                        statusOptions: [
                                            {
                                                id: 0,
                                                name: "正常",
                                                color: "#52C41A",
                                                is_default: 1,
                                                switch_type: 0,
                                                switch_support_types: [1, 2, 3],
                                                switch_is_required: 1,
                                            },
                                            {
                                                id: 0,
                                                name: "异常",
                                                color: "#F5222D",
                                                is_default: 0,
                                                switch_type: 0,
                                                switch_support_types: [1, 2, 3],
                                                switch_is_required: 1,
                                            },
                                        ],
                                        who_type: 0,
                                        customer_ids: [],
                                        rules: [],
                                    },
                                ],
                            },
                        });
                    } else {
                        this.$Message.error(
                            "状态面板组件限制一个页面只能添加一个"
                        );
                    }
                    break;
                // 29：动态数据面板
                case 29:
                    this.formData.splice(this.index_id, 0, {
                        type: 29,
                        name: "动态数据面板",
                        content: {
                            version: 1,
                            title: "最近动态",
                            title_size: "20",
                            title_color: "#000",
                            dec_color: "#FF761D ",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            content_size: "15",
                            content_color: "#000",
                            who_type: "0",
                            customer_ids: [],
                            mode_id: "1",
                            line_color: "#FF761D ",
                            circle_color: "#FF761D ",
                            mode_img: { value: "", picview: "" },
                            btn_color: "#fff",
                            border_color: "#FF761D ",
                            btn_text_color: "#FF761D ",
                            mask_color: "#FFF8F4",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                // 30：操作面板
                case 30:
                    const hasType30 = this.formData.some(
                        (item) => item.type === 30
                    ); //限制
                    if (!hasType30) {
                        this.formData.splice(this.index_id, 0, {
                            type: 30,
                            name: "操作面板",
                            key: this.admin_id + "a" + Date.now(),
                            content: {
                                version: 1,
                                style_value: "1", // 样式一 样式二
                                title: "操作入口",
                                title_size: "14",
                                title_color: "#000",
                                bg_color: "#fff",
                                bg_value: 0,
                                bg_img: { value: "", picview: "" },
                                marginData: { top: 0, left: 0 },
                                paddingData: { top: 12, left: 12 },
                                radiusData: { top: 0, bottom: 0 },
                                controlList: [
                                    {
                                        btn_title: "操作标题",
                                        btn_desc: "操作说明",
                                        btn_text: "操作",
                                        btn_title_color: "#000",
                                        btn_desc_color: "#666",
                                        btn_text_color: "#fff",
                                        btn_color: "#FF761D",
                                        border_color: "#FF761D",
                                        bg_color: "#f2f7fa",
                                        formList: [
                                            {
                                                type: 1,
                                                field_key: generateFieldKey(1),
                                                name: "表单名称",
                                                content: {
                                                    title: "表单名称",
                                                    title_size: "18",
                                                    title_color: "#000",
                                                    title_position: "center",
                                                    bg_color: "#fff",
                                                    bg_value: 0,
                                                    bg_img: {
                                                        value: "",
                                                        picview: "",
                                                    },
                                                    outer_spacing: {
                                                        top: 0,
                                                        left: 0,
                                                    },
                                                    inner_spacing: {
                                                        top: 12,
                                                        left: 12,
                                                    },
                                                    rounded_corner_setting: {
                                                        top: 0,
                                                        bottom: 0,
                                                    },
                                                },
                                            },
                                            {
                                                type: 20,
                                                field_key: generateFieldKey(20),
                                                name: "提交按钮",
                                                content: {
                                                    title: "提交",
                                                    title_color: "#fff",
                                                    border_color: "#FF761D",
                                                    button_submit_color:
                                                        "#FF761D",
                                                    cannot_submit_border_color:
                                                        "#666",
                                                    button_cannot_submit_color:
                                                        "#666",
                                                    bg_color: "#fff",
                                                    bg_value: 0,
                                                    bg_img: {
                                                        value: "",
                                                        picview: "",
                                                    },
                                                    outer_spacing: {
                                                        top: 12,
                                                        left: 12,
                                                    },
                                                    inner_spacing: {
                                                        top: 6,
                                                        left: 0,
                                                    },
                                                    rounded_corner_setting: {
                                                        top: 20,
                                                        bottom: 20,
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        });
                    } else {
                        this.$Message.error(
                            "操作面板组件限制一个页面只能添加一个"
                        );
                    }
                    break;
                default:
                    console.log("DIY");
                    break;
            }
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    margin-right: 50px;
    font-weight: 400;
    font-size: 16px;
    color: #484e66;
}
.flex-w {
    flex-wrap: wrap;
}
.card-btn,
.card-btn-none {
    padding-left: 12px;
    margin: 6px 0;
    width: 130px;
    height: 42px;
    background: #ffffff;
    border: 1px solid #dce5eb;
    border-radius: 3px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.card-btn-none {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #484e66;
}
.c-p {
    cursor: pointer;
}
</style>